// Compares "web-1.14.2" style versions. Same scheme as VOICE_CLIENT_VERSION
// and Vocabulary's minSupportedClientVersion — strip the platform prefix,
// compare the numeric parts.
export function isVersionSupported(current: string, minSupported: string): boolean {
  const toParts = (v: string) =>
    v
      .replace(/^[a-zA-Z]+-/, "")
      .split(".")
      .map((n) => parseInt(n, 10) || 0);

  const currentParts = toParts(current);
  const minParts = toParts(minSupported);

  for (let i = 0; i < Math.max(currentParts.length, minParts.length); i++) {
    const c = currentParts[i] ?? 0;
    const m = minParts[i] ?? 0;
    if (c > m) return true;
    if (c < m) return false;
  }
  return true; // equal
}
